export default __webpack_public_path__ + "static/media/Logo.543205b4.png";